
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/guida-estate",
      function () {
        return require("private-next-pages/[region]/[resort]/guida-estate.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/guida-estate"])
      });
    }
  